import { getDocument } from "../../../state/react-page";
import { useSelector } from "./use-selector";
function useDocument(documentKey) {
  return useSelector((state) => getDocument(state, documentKey));
}
export {
  useDocument
};
//# sourceMappingURL=use-document.js.map